import React, { useEffect, useState, useCallback } from 'react';
import { BasicTableRow, getBasicTableData, Pagination } from 'api/clinicsGet.api';
import { BaseTable } from '@app/components/common/BaseTable/BaseTable';
import { ColumnsType } from 'antd/es/table';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';
import { defineColorByPriority } from '@app/utils/utils';
import { notificationController } from 'controllers/notificationController';
import { Status } from '@app/components/profile/profileCard/profileFormNav/nav/payments/paymentHistory/Status/Status';
import { useMounted } from '@app/hooks/useMounted';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { deleteVariantAction, getAllCategoriesAction, getAllVariantAction } from '@app/store/slices/userSlice';
import { Popconfirm } from 'antd';
const initialPagination: Pagination = {
  current: 1,
  pageSize: 20,
};

export const BasicTable: React.FC = () => {
  const [tableData, setTableData] = useState<{ data: BasicTableRow[]; pagination: Pagination; loading: boolean }>({
    data: [],
    pagination: initialPagination,
    loading: false,
  });
  const { t } = useTranslation();
  const { isMounted } = useMounted();
  let navigate = useNavigate();


  const dispatch = useAppDispatch();
const fetchData=()=>{
  dispatch(getAllVariantAction())
  .unwrap()
  .then((resp) => {

    setTableData({ ...tableData, data: resp.data });

  }).catch((err) => {
    notificationController.error({ message: err.message });
  })
}
  useEffect(() => {
    fetchData();

  }, []);

  const fetch = useCallback(
    (pagination: Pagination) => {
      setTableData((tableData) => ({ ...tableData, loading: true }));
      // getBasicTableData(pagination).then((res) => {
      //   if (isMounted.current) {
      //     setTableData({ data: res.data, pagination: res.pagination, loading: false });
      //   }
      // });
    },
    [isMounted],
  );

  useEffect(() => {
    fetch(initialPagination);
  }, [fetch]);

  const handleTableChange = (pagination: Pagination) => {
    fetch(pagination);
  };

  const handleDeleteRow = async (id: string) => {
    try {
      // Replace this with your actual API call
      const response = await dispatch(deleteVariantAction(id)).unwrap();
  
      if (response.success) {
        notificationController.success({
          message: 'Item deleted successfully!',
        });
  
        // Refresh data or perform additional actions
        fetchData();
      } else {
        notificationController.error({
          message: response?.message || 'Failed to delete the item. Please try again.',
        });
      }
    } catch (error) {
      console.error('Error deleting item:', error);
      notificationController.error({
        message: 'An error occurred while deleting the item.',
      });
    }
  };

  const columns: ColumnsType<BasicTableRow> = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (text: string) => <span>{text}</span>,

    },

    {
      title: "Options",
      key: 'values',
      render: (_text, record) => (
        <>
          {record?.values?.map((item: any, index: number) => (
            <span key={index}>
              {item.quantity} {item.unit}
              {index < record.values.length - 1 && ", "}
            </span>
          ))}
        </>
      ),
    },
    
    {
      title: t('tables.actions'),
      dataIndex: 'actions',
      width: '15%',
      render: (text: string, record: any) => {
        return (
          <BaseSpace>
            <BaseButton
              type="ghost"
              onClick={() => {
                navigate('/admin/variants/edit/' + record?._id)
                // notificationController.info({ message: t('tables.inviteMessage', { name: record.name }) });
              }}
            >
              {t('common.edit')}
            </BaseButton>

            <BaseButton type="ghost">
  <Popconfirm
    title="Are you sure you want to delete this item?"
    onConfirm={() => handleDeleteRow(record?._id)}
    okText="Yes"
    cancelText="No"
  >
    {t('common.delete')}
  </Popconfirm>
</BaseButton>
          </BaseSpace>
        );
      },
    },
  ];

  return (
    <BaseTable
      columns={columns}
      dataSource={tableData.data}
      pagination={tableData.pagination}
      loading={tableData.loading}
      onChange={handleTableChange}
      scroll={{ x: 800 }}
      bordered
    />
  );
};
